import { TextUtil } from '@suntex.core/animation';

/* eslint-disable no-magic-numbers */
export class TextIcon extends createjs.Container {
  constructor(text: string, opts: { fontFamily: string; size?: number }) {
    super();
    const isSingleChar = text.length === 1;
    const isMultiLine = text.indexOf('\n') >= 0;
    const textObj = TextUtil.createText(text, {
      color: '#FFF',
      font: {
        family: opts.fontFamily,
        size:
          opts.size ??
          (isSingleChar
            ? 96
            : text.length > 10
              ? Math.max(32 - Math.floor(text.length / 2), 12)
              : 64 - (text.length + 1) * 4),
        bold: isSingleChar,
      },
      textAlign: 'center',
      textBaseline: isMultiLine ? 'top' : 'middle',
    });
    this.addChild(textObj);
    if (isMultiLine) {
      textObj.y = textObj.getMeasuredHeight() / -2;
    }
  }
}
